import { useState } from 'react';
import { Switch } from './Switch';

type Props = {
  enabled: boolean;
  /** Resolves false when the change did not take (demo not available yet). */
  onChange: (enabled: boolean) => Promise<boolean>;
};

/**
 * Per-pack switch for the free demo rip: players open the pack without
 * signing up or paying. Saves on click, like the publish control.
 */
export function DemoToggle({ enabled, onChange }: Props) {
  const [saving, setSaving] = useState(false);
  const [unavailable, setUnavailable] = useState(false);

  async function toggle() {
    setSaving(true);
    try {
      setUnavailable(!(await onChange(!enabled)));
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="flex items-start gap-3">
      <Switch checked={enabled} label="Free demo rip" disabled={saving} onClick={() => void toggle()} />
      <div>
        <div className="text-[12px] font-medium text-[var(--co-text)]">
          Free demo rip {enabled ? 'on' : 'off'}
        </div>
        <p className="text-[11px] text-[var(--co-muted)]">
          Players can try this pack for free without signing up. The demo always shows a good card
          and nothing is charged or kept.
        </p>
        {unavailable && (
          <p role="status" className="mt-1 text-[11px] font-medium text-amber-700">
            Coming soon — free demo rips aren&apos;t available for your account yet. We&apos;ll let
            you know when you can turn them on.
          </p>
        )}
      </div>
    </div>
  );
}
